import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=0a35cad1&scoped=true&"
import script from "./imgUpload.vue?vue&type=script&lang=js&"
export * from "./imgUpload.vue?vue&type=script&lang=js&"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=0a35cad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a35cad1",
  null
  
)

export default component.exports